import React, { FC, useCallback } from "react";
import OnboardingForm from "@components/Onboarding/OnboardingForm/OnboardingForm";
import { useTranslation } from "react-i18next";
import { OnboardingFormActionContainer } from "@components/Onboarding/OnboardingForm";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Patient } from "@models/patient";
import PicturesUpload from "@components/PicturesUpload/PicturesUpload";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";

const OnboardingPicturesUpload: FC<{ patient: Patient }> = ({ patient }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const next = () => {
    navigate(`/onboarding/characters`);
  };

  const onPrevious = useCallback(() => {
    const previousUrl = patient
      ? `/onboarding/${patient.id}/family-info`
      : "/onboarding/family-info";
    navigate(previousUrl);
  }, [navigate, patient]);

  return (
    <OnboardingForm
      title={t("picturesUpload.title")}
      subtitle={t("picturesUpload.subtitle", {
        patientNickName: patient?.nickname || patient?.firstName || "",
      })}
      icon={<AddPhotoAlternateOutlinedIcon fontSize="small" />}
    >
      <Box width="100%">
        <PicturesUpload
          patient={patient}
          buttons={({ save, isSubmitting }) => {
            return (
              <OnboardingFormActionContainer
                style={{ marginTop: "100px" }}
                isSubmitting={isSubmitting}
                onSubmit={async () => {
                  await save();
                  next();
                }}
                onPrevious={onPrevious}
              />
            );
          }}
        />
      </Box>
    </OnboardingForm>
  );
};

export default OnboardingPicturesUpload;
